import { styled } from 'styled-components';

import { colors, cssBreakpoints } from 'theme/theme';

export const TileModalDesktopHeaderHolder = styled.div`
  display: flex;
  flex-direction: column;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const TileModalDesktopHeaderBlueLine = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 15px;
  background: ${colors.brandBlue};
`;

export const TileModalDesktopHeaderCloseHolder = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 39px;
  margin-top: 20px;
`;
